console.log("init Proteus treatments -- 1.01");

// onward checkout button patch
observeSelector('[name="checkout"]', checkout => {
  console.log("found checkout button");
  checkout.id = "checkout";
});

waitForElement('.product-info__buy-buttons').then(buy_buttons => {
  waitForElement('#BIS_trigger').then(bis_button => {
    buy_buttons.insertAdjacentHTML("beforebegin", `
    <style>
    .product-info__buy-buttons{
      position: relative;
    }
    .product-info__buy-buttons #BIS_trigger{
      position: absolute;
      z-index: 5;
      top: 0;
      left: 0;
      width: 70%;
      height: 100%;
    }
    .product-info__buy-buttons button[disabled],
    .product-info__buy-buttons button[disabled] *{
      color: transparent !important;
    }
    </style>
    `);

    buy_buttons.insertAdjacentElement("afterbegin", bis_button)
  }).catch();
}).catch();

//START quick buy drawer color swap logic
proteus.quickBuyPrefetchCache = {};

// Fetch and cache a product's quick-buy content fragment
proteus.quickBuyFetch = (handle) => {
  if (proteus.quickBuyPrefetchCache[handle]) return proteus.quickBuyPrefetchCache[handle];

  const promise = fetch(`${window.Shopify.routes.root}products/${handle}`)
    .then(r => r.text())
    .then(html => {
      const content = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('quick-buy-content')?.content;
      if (content) {
        Array.from(content.querySelectorAll('noscript')).forEach(n => n.remove());
        proteus.quickBuyPrefetchCache[handle] = content;
      }
      return content || null;
    });

  proteus.quickBuyPrefetchCache[handle] = promise;
  return promise;
};

// Prefetch all color swatch targets from within a container
proteus.quickBuyPrefetch = (container) => {
  container.querySelectorAll('.product-info__product-picker a').forEach(swatch => {
    const url = swatch.getAttribute('href');
    const handle = url?.split('/products/')[1]?.split('?')[0];
    if (handle) proteus.quickBuyFetch(handle);
  });
};

// Intercept color swatch clicks in both drawer and hover-quick-buy containers
proteus.quickBuyColorSwap = async (event) => {
  const swatch = event.target.closest(
    'quick-buy-drawer .product-info__product-picker a, [data-hover-quick-buy] .product-info__product-picker a'
  );
  if (!swatch) return;

  event.preventDefault();

  const container = swatch.closest('quick-buy-drawer') || swatch.closest('[data-hover-quick-buy]');
  if (!container) return;

  const url = swatch.getAttribute('href');
  const handle = url?.split('/products/')[1]?.split('?')[0];
  if (!handle) return;

  container.setAttribute('aria-busy', 'true');

  const result = await proteus.quickBuyFetch(handle);
  const content = result instanceof DocumentFragment ? result.cloneNode(true) : null;

  container.setAttribute('aria-busy', 'false');
  if (!content) return;

  container.replaceChildren(content);
  container._hasLoaded = true;

  proteus.quickBuyPrefetch(container);
};

// Prefetch when drawer finishes its initial load
proteus.observe_selector('quick-buy-drawer', (drawer) => {
  const mo = new MutationObserver(() => {
    if (drawer.getAttribute('aria-busy') === 'false') {
      proteus.quickBuyPrefetch(drawer);
    }
  });
  mo.observe(drawer, { attributes: true, attributeFilter: ['aria-busy'] });
});

document.addEventListener('click', proteus.quickBuyColorSwap);
//END quick buy drawer color swap logic


//START quick buy drawer flow modification
customElements.whenDefined('quick-buy-drawer').then(() => {
  document.addEventListener('variant:add', function(event) {
    const drawer = document.querySelector('quick-buy-drawer[open][data-skip-variant-added="true"]');
    if (!drawer) return;

    Promise.resolve().then(() => {
      event.detail.blockCartDrawerOpening = false;
      drawer.hide();
      document.querySelector('cart-drawer')?.show();
    });
  }, true);
});
//END quick buy drawer flow modification


//START hover buy fast cart drawer + skeleton
(function() {
  var styleInjected = false;

  function injectStyles() {
    if (styleInjected) return;
    styleInjected = true;
    var s = document.createElement('style');
    s.textContent = [
      '@keyframes proteus-shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }',
      '.cart-drawer__skeleton .line-item__media-wrapper { aspect-ratio:3/4; border-radius:var(--rounded-xs); }',
      '.cart-drawer__skeleton-info { flex:1; display:grid; gap:8px; padding-top:2px; }',
      '.cart-drawer__skeleton-line { height:13px; border-radius:3px; }',
      '.cart-drawer__skeleton .line-item__media-wrapper,.cart-drawer__skeleton-line { background:linear-gradient(90deg,rgb(var(--text-color)/.07) 25%,rgb(var(--text-color)/.13) 50%,rgb(var(--text-color)/.07) 75%); background-size:200% 100%; animation:proteus-shimmer 1.3s ease-in-out infinite; }'
    ].join(' ');
    document.head.appendChild(s);
  }

  function buildSkeleton() {
    var el = document.createElement('div');
    el.className = 'line-item cart-drawer__skeleton';
    el.setAttribute('data-hover-skeleton', '');
    el.innerHTML =
      '<div class="line-item__media-wrapper"></div>' +
      '<div class="cart-drawer__skeleton-info">' +
        '<div class="cart-drawer__skeleton-line" style="width:65%"></div>' +
        '<div class="cart-drawer__skeleton-line" style="width:40%"></div>' +
        '<div class="cart-drawer__skeleton-line" style="width:50%;margin-top:6px"></div>' +
      '</div>';
    return el;
  }

  function showCartWithSkeleton() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    injectStyles();
    if (typeof cartDrawer.show === 'function') cartDrawer.show();
    var lineItems = cartDrawer.querySelector('.cart-drawer__line-items');
    if (lineItems) {
      if (!lineItems.querySelector('[data-hover-skeleton]')) {
        lineItems.insertBefore(buildSkeleton(), lineItems.firstChild);
      }
    } else {
      var emptyState = cartDrawer.querySelector('.empty-state');
      if (emptyState && !cartDrawer.querySelector('[data-hover-skeleton]')) {
        emptyState.hidden = true;
        var wrapper = buildSkeleton();
        wrapper.style.padding = 'var(--spacing-6)';
        cartDrawer.appendChild(wrapper);
      }
    }
  }

  // Trigger on pill click inside the hover overlay
  document.addEventListener('click', function(e) {
    var pill = e.target.closest('[data-add-variant-id]');
    if (!pill || pill.getAttribute('aria-disabled') === 'true') return;
    if (!pill.closest('[data-hover-quick-buy]')) return;
    showCartWithSkeleton();
  }, { capture: false });
})();
//END hover buy fast cart drawer + skeleton


//START product card silhouette + hover buy
(function() {
  var cardStyleInjected = false;

  function injectCardStyles() {
    if (cardStyleInjected) return;
    cardStyleInjected = true;
    var s = document.createElement('style');
    s.textContent = [
      // card figure
      '.product-card__figure{aspect-ratio:14/19;overflow:hidden;}',
      '.product-card__aside{width:100%;min-width:0;overflow:hidden;}',

      // silhouette scroller
      '.product-card__silhouette-scroller{flex-wrap:nowrap;gap:0.1rem;width:100%;min-width:0;max-width:100%;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;scrollbar-width:none;margin:0;padding:2px 0;border:0;}',
      '.product-card__silhouette-scroller::-webkit-scrollbar{display:none;}',
      '.product-card__silhouette-scroller>.product-card__silhouette-swatch{flex:0 0 auto;margin-left:2px;margin-right:2px;}',

      // hover overlay container
      '.product-card__hover-quick-buy{position:absolute;inset-inline:0;bottom:0;padding:10px;background:rgb(var(--background)/.95);opacity:0;transform:translateY(8px);transition:opacity 0.2s ease,transform 0.2s ease;pointer-events:none;z-index:2;display:flex;flex-direction:column;gap:12px;}',
      '@media (hover:hover) and (pointer:fine) and (min-width:700px){.product-card:hover .product-card__hover-quick-buy,.product-card:focus-within .product-card__hover-quick-buy{opacity:1;transform:translateY(0);pointer-events:auto;}}',
      '@media (hover:hover) and (pointer:fine) and (min-width:700px){.product-card__hover-buy-fallback-icon{display:none;}}',

      // color swatches — reset theme margin, rely on container gap
      '.product-card__hover-swatches .color-swatch{margin:0;}',
      '.product-card__hover-more-swatches{appearance:none;background:none;border:0;padding:5px 8px;cursor:pointer;font:inherit;font-size:0.75rem;font-weight:600;color:rgb(var(--text-color));text-decoration:underline!important;text-underline-offset:2px;white-space:nowrap;align-self:center;}',

      // pills
      '.product-card__hover-buy-form{margin:0;}',
      '.product-card__hover-buy-pills{display:flex;flex-wrap:nowrap;gap:4px;justify-content:center;overflow:hidden;}',
      '.product-card__hover-buy-pill{appearance:none;background:rgb(var(--background));border:1px solid rgb(var(--text-color)/.18);padding:3px 6px;font:inherit;font-size:0.72rem;font-weight:600;letter-spacing:0.04em;border-radius:4px;cursor:pointer;color:rgb(var(--text-color));min-width:0;flex:1 1 0;display:inline-flex;align-items:center;justify-content:center;text-align:center;transition:background 0.15s,color 0.15s,border-color 0.15s;}',
      '.product-card__hover-buy-pill:hover:not(.is-disabled),.product-card__hover-buy-pill:focus-visible:not(.is-disabled){background:rgb(var(--button-background-primary));color:rgb(var(--button-text-primary));border-color:rgb(var(--button-background-primary));outline:none;}',
      '.product-card__hover-buy-pill.is-disabled{color:rgb(var(--text-color)/.35);cursor:not-allowed;background-image:linear-gradient(to bottom right,transparent calc(50% - 0.5px),currentColor 50%,currentColor calc(50% + 1.5px),transparent calc(50% + 2px));}',
      '.product-card__hover-buy-pill[aria-busy="true"]{opacity:0.5;pointer-events:none;}',
    ].join('');
    document.head.appendChild(s);
  }

  function initCard(card) {
    injectCardStyles();

    // --- silhouette swatch init ---
    if (!card.dataset.silhouetteInit) {
      var swatches = card.querySelectorAll('[data-silhouette-swatch]');
      if (swatches.length) {
        card.dataset.silhouetteInit = 'true';

        var primaryImg           = card.querySelector('[data-card-primary-image]');
        var secondaryImg         = card.querySelector('[data-card-secondary-image]');
        var colorName            = card.querySelector('[data-card-color-name]');
        var links                = card.querySelectorAll('[data-card-link]');
        var quickBuyDrawer       = card.querySelector('[data-quick-buy-drawer]');
        var quickBuyForm         = card.querySelector('[data-quick-buy-container] form[is="product-form"]');
        var quickBuyVariantInput = quickBuyForm ? quickBuyForm.querySelector('input[name="id"]') : null;
        var quickBuyTrigger      = card.querySelector('[data-quick-buy-trigger]');
        var hoverBuyPills        = card.querySelector('[data-hover-buy-pills]');
        var hoverBuyIdInput      = card.querySelector('[data-hover-buy-id]');

        function escapeHtml(s) {
          return String(s).replace(/[&<>"']/g, function(c) {
            return({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
          });
        }

        function rebuildHoverBuyPills(sw) {
          if (!hoverBuyPills) return;
          var raw = sw.dataset.productVariants;
          if (!raw) return;
          try {
            var variants = JSON.parse(raw);
            var addLabel = hoverBuyPills.dataset.addLabel || '';
            hoverBuyPills.innerHTML = variants.map(function(v) {
              var disabled = !v.available;
              var label = addLabel ? escapeHtml(addLabel + ' — ' + v.size) : escapeHtml(v.size);
              return '<button type="button" class="product-card__hover-buy-pill' + (disabled ? ' is-disabled' : '') +
                '" data-add-variant-id="' + v.id + '"' + (disabled ? ' aria-disabled="true"' : '') +
                ' aria-label="' + label + '"><span>' + escapeHtml(v.size) + '</span></button>';
            }).join('');
            if (hoverBuyIdInput) {
              var first = variants.filter(function(v) { return v.available; })[0] || variants[0];
              if (first) hoverBuyIdInput.value = first.id;
            }
          } catch(e) {}
        }

        var selectedSwatch = card.querySelector('[data-silhouette-swatch].is-selected') || swatches[0];

        function readSwatch(sw) {
          return {
            img: sw.dataset.productImage,
            srcset: sw.dataset.productImageSrcset,
            secondaryImg: sw.dataset.productSecondaryImage,
            secondarySrcset: sw.dataset.productSecondaryImageSrcset,
            url: sw.dataset.productUrl,
            color: sw.dataset.colorName,
            handle: sw.dataset.productHandle,
            variantId: sw.dataset.productVariantId
          };
        }

        function paint(data) {
          if (primaryImg && data.img) { primaryImg.src = data.img; if (data.srcset) primaryImg.srcset = data.srcset; }
          if (secondaryImg && data.secondaryImg) { secondaryImg.src = data.secondaryImg; if (data.secondarySrcset) secondaryImg.srcset = data.secondarySrcset; }
          if (colorName && data.color) colorName.textContent = data.color;
          links.forEach(function(l) { if (data.url) l.href = data.url; });
        }

        function syncQuickBuy() {
          var data = readSwatch(selectedSwatch);
          if (quickBuyDrawer && data.handle) quickBuyDrawer.setAttribute('handle', data.handle + (data.variantId ? '?variant=' + data.variantId : ''));
          if (quickBuyVariantInput && data.variantId) quickBuyVariantInput.value = data.variantId;
        }

        syncQuickBuy();

        if (quickBuyTrigger) {
          ['pointerdown', 'touchstart', 'focus'].forEach(function(evt) {
            quickBuyTrigger.addEventListener(evt, syncQuickBuy, { passive: true });
          });
        }

        function preload(sw) {
          if (sw.dataset.secondaryPreloaded) return;
          sw.dataset.secondaryPreloaded = 'true';
          [sw.dataset.productSecondaryImage, sw.dataset.productImage].forEach(function(src, i) {
            if (!src) return;
            var img = new Image();
            var srcset = i === 0 ? sw.dataset.productSecondaryImageSrcset : sw.dataset.productImageSrcset;
            if (srcset) img.srcset = srcset;
            img.src = src;
          });
        }

        swatches.forEach(function(sw) {
          sw.addEventListener('mouseenter', function() { preload(sw); paint(readSwatch(sw)); });
          sw.addEventListener('focus',      function() { preload(sw); paint(readSwatch(sw)); });
          sw.addEventListener('mouseleave', function() { paint(readSwatch(selectedSwatch)); });
          sw.addEventListener('blur',       function() { paint(readSwatch(selectedSwatch)); });
          sw.addEventListener('click', function() {
            preload(sw);
            selectedSwatch = sw;
            paint(readSwatch(sw));
            swatches.forEach(function(s) {
              var match = s.dataset.productId === sw.dataset.productId;
              s.classList.toggle('is-selected', match);
              s.setAttribute('aria-current', match ? 'true' : 'false');
            });
            syncQuickBuy();
            rebuildHoverBuyPills(sw);
          });
        });
      }
    }

    // --- hover buy pill click init ---
    if (!card.dataset.hoverBuyInit) {
      var pillsContainer = card.querySelector('[data-hover-buy-pills]');
      if (pillsContainer) {
        card.dataset.hoverBuyInit = 'true';
        var hoverForm    = card.querySelector('.product-card__hover-buy-form');
        var hoverIdInput = card.querySelector('[data-hover-buy-id]');
        if (hoverForm && hoverIdInput) {
          var activeBtn    = null;
          var fallbackTimer = null;

          function clearBusy() {
            if (fallbackTimer) { clearTimeout(fallbackTimer); fallbackTimer = null; }
            if (activeBtn) { activeBtn.removeAttribute('aria-busy'); activeBtn = null; }
          }

          card.addEventListener('variant:add',       clearBusy);
          card.addEventListener('variant:add-error', clearBusy);

          pillsContainer.addEventListener('click', function(e) {
            var btn = e.target.closest('[data-add-variant-id]');
            if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
            var vid = btn.getAttribute('data-add-variant-id');
            if (!vid) return;
            hoverIdInput.value = vid;
            clearBusy();
            activeBtn = btn;
            btn.setAttribute('aria-busy', 'true');
            fallbackTimer = setTimeout(clearBusy, 8000);
            if (typeof hoverForm.requestSubmit === 'function') {
              hoverForm.requestSubmit();
            } else {
              hoverForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            }
          });
        }
      }
    }
  }

  proteus.observe_selector('product-card', initCard);
})();
//END product card silhouette + hover buy

//START Frenzy product card price fix
// Frenzy injects tabindex="0" + aria-label on .frenzy_product_price_sale spans.
// The element is static text — tabindex makes it an unnecessary tab stop and causes
// iOS to show a tap highlight. The aria-label is also redundant (text content suffices).
proteus.observe_selector('.frenzy_product_price_sale', el => {
  function clean() {
    el.removeAttribute('tabindex');
    el.removeAttribute('aria-label');
  }
  clean();
  new MutationObserver(clean).observe(el, {
    attributes: true,
    attributeFilter: ['tabindex', 'aria-label'],
  });
});
//END Frenzy product card price fix

// start SUPPORT clearance
if(window.location.href.indexOf("/collections/") > -1 && window.location.href.indexOf("/products/") == -1){
  // collections view

  observeSelector('[data-prod-id="7302082494551"], [data-prod-id="7302085279831"], [data-prod-id="7246380269655"], [data-prod-id="6919194083415"], [data-prod-id="7060502839383"], [data-prod-id="6967691640919"], [data-prod-id="7207295647831"], [data-prod-id="7207171850327"], [data-prod-id="7245165068375"], [data-prod-id="7207170637911"], [data-prod-id="7207171719255"], [data-prod-id="7207170998359"], [data-prod-id="7245188038743"], [data-prod-id="7245199835223"], [data-prod-id="7245198327895"], [data-prod-id="7207295516759"], [data-prod-id="7386146275415"], [data-prod-id="7386147258455"], [data-prod-id="7386147389527"], [data-prod-id="7386135593047"], [data-prod-id="7386132643927"], [data-prod-id="7209748004951"], [data-prod-id="7386139394135"], [data-prod-id="6967695474775"]', clearance_item => {
    // 7654610337879 [Unreal Fit Bra] is placeholder - Removed from the list after client approval
    // clearance_item.closest('.fpid_grid').querySelector('.frenzy_product_price_meta').insertAdjacentHTML("beforeend", "*");

    waitForElement('.rich-text__collapsible').then(seo_snippet => {
      if(seo_snippet.innerText.toLowerCase().indexOf("*pricing policy") == -1){
        seo_snippet.insertAdjacentHTML("beforeend", `
        <h6>*Pricing Policy</h6>
        <p>The referenced price, from which all discounts are calculated, is our suggested retail price (“MSRP”) based on several factors, and is not intended to represent a price previously offered. The MSRP may not represent a price at which substantial sales have been made. Sales are subject to product availability and may end without notice once inventory is depleted or at our sole discretion.</p>
        `);
      }
    }).catch();

  });
}
  
// end SUPPORT clearance